import { FILE_DOWNLOAD, FILE_UPLOAD } from '@gameday/common/constants/endpoints'

export default {
  upload: FILE_UPLOAD, // 'gamedayapi/files/upload',
  download: FILE_DOWNLOAD, // 'gamedayapi/files/download',
  uploadDirect: 'files/upload',
  downloadDirect: 'files/download',
  documentUploadDirect: 'private-documents/upload',
}
